import { FC, useContext, useState } from 'react';

import { useMutation } from '@apollo/client';
import { Button, H2, Modal, NumberInput } from '@smartshell/ui-kit';
import { useNavigate } from 'react-router';

import { LocalizationContext } from 'localization';
import {
  GENERATE_PROMO_CODES,
  GET_PROMO_CAMPAIGNS,
  IGeneratePromoCodeRequest,
  IGeneratePromoCodeResponse,
} from 'schemas';
import notification from 'services/notificationService';

import { EPromoCodeMode } from '../../../types';
import s from './GeneratePromoModal.module.scss';
import { IGeneratePromoModalProps } from './interfaces';

export const GeneratePromoModal: FC<IGeneratePromoModalProps> = ({
  onClose,
  id,
}) => {
  const { t } = useContext(LocalizationContext);
  const navigate = useNavigate();

  const [generationPromo, { loading }] = useMutation<
    IGeneratePromoCodeResponse,
    IGeneratePromoCodeRequest
  >(GENERATE_PROMO_CODES, {
    onCompleted: () => {
      notification.info({
        t,
        type: 'success',
        message: t('promo_group.notification.generate'),
        dismiss: 5,
      });
      onClose();
      navigate('/promo-codes', {
        state: { activeTab: EPromoCodeMode.CAMPAIGN },
      });
    },
    refetchQueries: [GET_PROMO_CAMPAIGNS],
  });

  const [count, setCount] = useState<number | ''>('');
  const [error, setError] = useState<string>('');

  return (
    <Modal className={s.container} onClose={onClose}>
      <H2 className={s.title}>{t('promo.generate.modal.title')}</H2>
      <NumberInput
        value={count}
        onChange={(value) => {
          if (value > 1000) {
            setError(t('errors.max', 1000));
          }
          if (value < 1) {
            setError(t('errors.min', 1));
          }
          if (value > 0 && value < 1001) {
            setError('');
          }
          setCount(value);
        }}
        title={t('promo.generate.count')}
        errorWrapperClassName={s.input}
        error={error}
      />
      <div className={s.buttons_block}>
        <Button
          fullWidth
          onClick={() => {
            return generationPromo({
              variables: { id: id, amount: count ? count : undefined },
            });
          }}
          isLoading={loading}
          disabled={!!error}
        >
          {t('reports.generate')}
        </Button>
        <Button fullWidth onClick={onClose} variant="secondary">
          {t('cancel')}
        </Button>
      </div>
    </Modal>
  );
};
